import styled from 'styled-components'

import FONTS from 'constants/fonts'

import { ErrorLogicProps } from 'components/base/Form/Input/Input/types'

import {
  errorLogic,
  errorStyles,
  warningLogic,
  warningStyles,
} from 'components/base/Form/Input/Input/styles'

export const Wrapper = styled.div`
  > input {
    ${(props): string | undefined => (errorLogic(props as unknown as ErrorLogicProps) && errorStyles) || (warningLogic(props as unknown as ErrorLogicProps) && warningStyles) || undefined}
  }
  display: flex;
`

export const SubInputGroup = styled.div`
  margin-right: 1rem;
  flex: 1;
  &:last-child {
    margin: 0;
    flex: 2;
  }
`

export const SubInputLabel = styled.label`
  display: block;
  font-size: ${FONTS.FONTLARGE};
  margin-bottom: 3px;
`
